<!--

    DEPRECATED COMPONENT

-->
<template>
    <div>
        <div class="mb-6 -mt-4">
            <h1>Proof of Address - Document Upload</h1>
        </div>

        <ValidationObserver ref="proofOfAddressDocumentObserver">
            <div class="mb-6">
                <p>Please upload an image of a valid document that provides proof of address.</p>
                <ul>
                    <li>Mobile phone bills are not accepted.</li>
                    <li>The utility bill should be dated within 90 days.</li>
                    <li>Name and address must be fully visible and must match that on the application.</li>
                    <li>
                        The proof of address needs to be a separate document to that submitted for ID (they should not
                        be the same). For example, if you provide your driving licence as proof of ID then you must
                        provide another form of identification for your address, such as a utility bill.
                    </li>
                    <li>
                        Other acceptable forms of address are: official government documentation, such as a council tax
                        bill, a bank or credit card statement or electoral registry/voter cards.
                    </li>
                </ul>
            </div>

            <div class="upload-guide mb-6">
                <div class="flex items-center mb-4">
                    <div class="mr-4 shrink-0">
                        <img width="30" height="30" :src="global.app.url + 'images/icons/upload-guide-focussed.svg'" />
                    </div>
                    <div class="">Make sure your document fills up most of the image. 80% is ideal.</div>
                </div>
                <div class="flex items-center mb-4">
                    <div class="mr-4 shrink-0">
                        <img width="30" height="30" :src="global.app.url + 'images/icons/upload-guide-plain.svg'" />
                    </div>
                    <div class="">The document needs to be on a plain background.</div>
                </div>
                <div class="flex items-center mb-4">
                    <div class="mr-4 shrink-0">
                        <img width="30" height="30" :src="global.app.url + 'images/icons/upload-guide-light.svg'" />
                    </div>
                    <div class="">
                        Avoid any glare or light reflection as the text needs to be clear, sharp and visible in the
                        image.
                    </div>
                </div>
                <div class="flex items-center">
                    <div class="mr-4 shrink-0">
                        <img width="30" height="30" :src="global.app.url + 'images/icons/upload-guide-plain.svg'" />
                    </div>
                    <div>
                        Documents can be in JPEG, PNG or PDF format and can be in colour or black and white. File size
                        must not exceed 8MB.
                    </div>
                </div>
            </div>

            <div class="mb-6">
                <FileUploadComponent
                    id="poa-document"
                    name="poa_document"
                    label="Upload an image"
                    :apiEndpointUrl="'/user/' + this.user.id + '/poa/document'"
                    :fileData="proofOfAddressDocument"
                    @change="updateProofOfAddressDocumentFileUrl"
                    accept="image/jpeg,image/png,application/pdf"
                />
            </div>
        </ValidationObserver>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { ValidationObserver } from "vee-validate";
import InputComponent from "@components/inputs/InputComponent";
import stepperValidationService from "@services/stepperValidationService";

export default {
    name: "POADocumentFormComponent",
    props: {},
    components: {
        ValidationObserver,
    },
    props: {
        step: { default: "" },
    },
    computed: {
        ...mapGetters(["global", "user", "proofOfAddressDocumentState"]),
    },
    data: function () {
        return {
            proofOfAddressDocument: {},
            isFormValidated: false,
        };
    },
    methods: {
        ...mapActions(["doGetProofOfAddressDocument", "doUpdateProofOfAddressDocumentFileUrl"]),
        updateProofOfAddressDocumentFileUrl() {
            this.doUpdateProofOfAddressDocumentFileUrl(this.proofOfAddressDocument);
        },
        doValidateForm() {
            stepperValidationService.checkStepperStepStatus(
                this.step,
                this.proofOfAddressDocument,
                this.$refs.proofOfAddressDocumentObserver,
                false,
                true
            );
        },
    },
    mounted() {
        this.$root.$on("submittingApplication", () => this.doValidateForm());
        this.$root.$on("stepChanged", (step) => {
            if (this.step < step && !this.isFormValidated) {
                this.doValidateForm();
                this.isFormValidated = true;
            } else if (this.step == step) {
                this.isFormValidated = false;
            }
        });

        this.doGetProofOfAddressDocument().then((response) => this.proofOfAddressDocument = response);
    },
    watch: {
        "proofOfAddressDocument.file_url"() {
            stepperValidationService.checkStepperStepStatus(
                this.step,
                this.proofOfAddressDocument,
                this.$refs.proofOfAddressDocumentObserver
            );
        },
    },
};
</script>
